import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "@/lib/constants";
import { Logo } from "@/components/Navbar";

const legalLinks = [
  { label: "Privacy Policy", to: "/privacy-policy", testId: "footer-privacy-policy-link" },
  { label: "Terms & Conditions", to: "/terms-and-conditions", testId: "footer-terms-link" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#08080A] text-white">
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <Logo dark />
          <p className="mt-4 text-[11px] font-semibold tracking-[0.18em] text-[#D8B54A]" data-testid="footer-descriptor">
            {BUSINESS.descriptor}
          </p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#8D877B]">
            {BUSINESS.shortName} provides financial education, credit education and personalized
            mentorship for individuals and entrepreneurs.
          </p>
        </div>
        <div>
          <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8D877B]">Explore</h3>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-[#C6C0B4] transition-colors duration-200 hover:text-white"
                >
                  {link.label}
                </Link>
              </li>
            ))}
            {legalLinks.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  data-testid={link.testId}
                  className="text-sm text-[#C6C0B4] transition-colors duration-200 hover:text-white"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8D877B]">Contact</h3>
          <div className="mt-5 space-y-4">
            <p className="flex items-start gap-3 text-sm leading-relaxed text-[#C6C0B4]" data-testid="footer-address">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#D8B54A]" />
              <span>
                {BUSINESS.name}
                <br />
                {BUSINESS.addressLine1}
                <br />
                {BUSINESS.addressLine2}
              </span>
            </p>
            <a
              href={BUSINESS.phoneHref}
              data-testid="footer-phone-link"
              className="flex items-center gap-3 text-sm font-semibold text-white transition-colors duration-200 hover:text-[#D8B54A]"
            >
              <Phone className="h-4 w-4 text-[#D8B54A]" />
              {BUSINESS.phone}
            </a>
          </div>
        </div>
      </div>
      <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-7 sm:flex-row sm:items-center">
        <p className="text-xs text-[#8D877B]" data-testid="footer-copyright">
          © {BUSINESS.name}. All rights reserved.
        </p>
        <div className="flex gap-6">
          {legalLinks.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              data-testid={`footer-bottom-${link.testId}`}
              className="text-xs text-[#8D877B] transition-colors duration-200 hover:text-white"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  </footer>
);
